"use client";
import { setRealmConfig, setRealmStorage } from "../actions";
import { resolveRealm } from "./resolveRealm";
export const storeAndReturnCurrentRealm = ({ openidRealmConfig, defaultRealm }) => {
    const resolvedRealm = resolveRealm({ openidRealmConfig, defaultRealm });
    const newRealm = {
        defaultRealm: resolvedRealm,
        ...openidRealmConfig[resolvedRealm],
    };
    setRealmConfig(newRealm);
    setRealmStorage(resolvedRealm);
    return newRealm;
};
//# sourceMappingURL=storeAndReturnCurrentRealm.js.map